import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import Breadcrumb from "./components/feature/Breadcrumb";
import ScrollToTop from "./components/feature/ScrollToTop";
import JsonLd from "./components/feature/JsonLd";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <JsonLd />
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <Breadcrumb />
          <div className="flex-1">
            <AppRoutes />
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
